<template>
    <div id="heavyTruck">
      <div class="container" v-if="currentImage">
        <h2  style="text-align: center">{{ currentImage.alt }}</h2>
        <img :src="currentImage.src" :alt="currentImage.alt" class="img-responsive" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/zhong1.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/zhong2.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/zhong3.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 4" :src="require('@/assets/img/zhong4.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 5" :src="require('@/assets/img/zhong5.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 6" :src="require('@/assets/img/zhong6.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 7" :src="require('@/assets/img/zhong7.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 8" :src="require('@/assets/img/zhong8.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 9" :src="require('@/assets/img/zhong9.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 10" :src="require('@/assets/img/zhong10.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 11" :src="require('@/assets/img/zhong11.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 12" :src="require('@/assets/img/zhong12.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 13" :src="require('@/assets/img/zhong13.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 14" :src="require('@/assets/img/zhong14.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 15" :src="require('@/assets/img/zhong15.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 16" :src="require('@/assets/img/zhong16.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 17" :src="require('@/assets/img/zhong17.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 18" :src="require('@/assets/img/zhong18.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 19" :src="require('@/assets/img/zhong19.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 20" :src="require('@/assets/img/zhong20.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 21" :src="require('@/assets/img/zhong21.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 22" :src="require('@/assets/img/zhong22.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 23" :src="require('@/assets/img/zhong23.png')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 24" :src="require('@/assets/img/zhong24.png')" style="max-width: 100%;" />

        <h2 v-html="currentImage.caption"></h2>
      </div>
      <div v-else>
        <p>没有找到相关的车型信息。</p>
      </div>
    </div>
  </template>
<style scoped>
.container table {
  margin: 100 auto;
}

.container {
padding: 50px 0;
text-align: center;
}

.container > * {
margin-left: auto;
margin-right: auto;
}
/* 自定义样式 */
.container {
    padding: 50px 0;
}
img {
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
}
/* 容器居中 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
}

/* 表头样式 */
.container th {
  background-color: #0d6efd; /* 蓝色表头 */
  color: white;
  padding: 15px;
  text-align: left;
  font-weight: bold;
}

/* 表格单元格样式 */
.container td {
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

/* 隔行变色 */
.container tr:nth-child(even) {
  background-color: #f9f9f9;
}

</style>
<style>
/* 全局样式 */
/* 容器居中 + 边框 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
  border: 1px solid #ddd; /* 添加表格整体边框 */
}

/* 表头和单元格边框 */
.container th,
.container td {
  border: 1px solid #ddd; /* 所有单元格加边框 */
  padding: 8px 10px;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
}

</style>
<script>
export default {
name: 'heavyTruck',
data() {
    return {
    currentImage: null,
    images: [
        {
        src: require('@/assets/img/zhongzhongka1.png'),
        alt: 'J7 6X4牵引',
        caption: ``,
        id: 1
        },
        {
        src: require('@/assets/img/zhongzhongka2.png'),
        alt: 'J7 4X2牵引',
        caption: ``,
        id: 2
        },
        {
        src: require('@/assets/img/zhongzhongka3.png'),
        alt: 'J6V 6×4 领航版牵引车',
        caption: ``,
        id: 3
        },
        {
        src: require('@/assets/img/zhongzhongka4.png'),
        alt: 'J6P 6×4 质惠版3.0牵引车',
        caption: ``,
        id: 4
        },
        {
        src: require('@/assets/img/zhongzhongka5.png'),
        alt: 'J6P 6×4 质惠版2.0+ LNG牵引车',
        caption: ``,
        id: 5
        },
        {
        src: require('@/assets/img/zhongzhongka6.png'),
        alt: 'J6P 6×4 价值版引车',
        caption: ``,
        id: 6
        },
        {
        src: require('@/assets/img/zhongzhongka7.png'),
        alt: 'J6P 4×2 定制版引车',
        caption: ``,
        id: 7
        },
        {
        src: require('@/assets/img/zhongzhongka8.png'),
        alt: '2022款新J6L 自卸车(8×4 公路标载)',
        caption: ``,
        id: 8
        },
        {
        src: require('@/assets/img/zhongzhongka9.png'),
        alt: '2022款新J6L 自卸车(8×4 复合渣土)',
        caption: ``,
        id: 9
        },
        {
        src: require('@/assets/img/zhongzhongka10.png'),
        alt: '2022款新J6L 自卸车(8×4 标载渣土)',
        caption: ``,
        id: 10
        },
        {
        src: require('@/assets/img/zhongzhongka11.png'),
        alt: '2022款新J6P 自卸车(6×4 工程矿用)',
        caption: ``,
        id: 11
        },
        {
        src: require('@/assets/img/zhongzhongka12.png'),
        alt: '2022款新J6P 自卸车(8×4 舒适版公路复合)',
        caption: ``,
        id: 12
        },
        {
        src: require('@/assets/img/zhongzhongka13.png'),
        alt: '2022款新J6P 自卸车(8×4 劲领版公路运输)',
        caption: ``,
        id: 13
        },
        {
        src: require('@/assets/img/zhongzhongka14.png'),
        alt: '2022款新J6P 自卸车(8×4 舒适版城建渣土)',
        caption: ``,
        id: 14
        },
        {
        src: require('@/assets/img/zhongzhongka15.png'),
        alt: 'J6G 4×2领航版载货车',
        caption: ``,
        id: 15
        },
        {
        src: require('@/assets/img/zhongzhongka16.png'),
        alt: 'J6P 8×4斜顶冷藏车',
        caption: ``,
        id: 16
        },
        {
        src: require('@/assets/img/zhongzhongka17.png'),
        alt: 'J6P 6×2内饰升级载货',
        caption: ``,
        id: 17
        },
        {
        src: require('@/assets/img/zhongzhongka18.png'),
        alt: 'J6L 6×2精英版载货',
        caption: ``,
        id: 18
        },
        {
        src: require('@/assets/img/zhongzhongka19.png'),
        alt: 'J6L 4×2大容积快递车',
        caption: ``,
        id: 19
        },
        {
        src: require('@/assets/img/zhongzhongka20.png'),
        alt: 'J6L 4×2精英版载货',
        caption: ``,
        id: 20
        },
        {
        src: require('@/assets/img/zhongzhongka21.png'),
        alt: 'J6L 4×2尊享版载货',
        caption: ``,
        id: 21
        },
        {
        src: require('@/assets/img/zhongzhongka22.png'),
        alt: 'J7 8×4平头载货车',
        caption: ``,
        id: 22
        },
        {
        src: require('@/assets/img/zhongzhongka23.png'),
        alt: 'J6P 6X4 平台牵引随吊车',
        caption: ``,
        id: 23
        },
        {
        src: require('@/assets/img/zhongzhongka24.png'),
        alt: 'J6L 4X2 平台清洗车',
        caption: ``,
        id: 24
        }
        
    ]
    };
},
mounted() {
    // 从路由参数中获取当前详情页的id
    const id = parseInt(this.$route.params.id);
    // 根据id匹配对应的图片数据
    this.currentImage = this.images.find(image => image.id === id) || null;
}
};
</script>




// WEBPACK FOOTER //
// src/view/heavyTruck.vue